import React, { useState, useEffect, useRef } from "react";
//redux
import { connect } from "react-redux";
// backdrops
import Alert from '../../../../components/Backdrops/Alert';
import Loading from '../../../../components/Backdrops/Loading';
import { useLocation } from "react-router-dom";
//service
import plusXMiceIdService from "../../../../utils/services/accreditation/plusXMiceId";
import adminUserService from "../../../../utils/services/accreditation/adminUser";
import scheduleService from "../../../../utils/services/accreditation/schedule";
import eventDoctorService from "../../../../utils/services/accreditation/eventDoctor";
import PlusXMiceIdModel from '../../../../utils/models/PlusXMiceIdModel';

import HasEventForm from './HasEventForm';
import ConfigurationsList from './ConfigurationsList';

function AccreditationConfigurations(props) {

  const location = useLocation();
  const eventId = location.state.idEvent;
  const [isLoading, setIsLoading] = useState(false);
  const [loadingControl, setLoadingControl] = useState({
    open: false,
    message: '',
  });
  const [alertControl, setAlertControl] = useState({
    open: false,
    title: '',
    message: '',
    status: '', // success, warning, error
  });
  const [attributesList, setAttributesList] = React.useState([]);
  const [attributesListLabel, setAttributesListLabel] = React.useState([]);
  const [schedulesList, setSchedulesList] = React.useState([]);
  const [configListBase, setConfigListBase] = React.useState([]);
  const [plusXMiceId, setPlusXMiceId] = React.useState(PlusXMiceIdModel());
  const plusXMiceIdRef = useRef(plusXMiceId);
  useEffect(() => {
    plusXMiceIdRef.current = plusXMiceId;
  }, [plusXMiceId]);
  const [configListForm, setConfigListForm] = useState({
    urlKioskMode: '',
    urlKioskModeLandscape: '',
    confirmedGuests: '',
    labelModel: '',
    labelField1: '',
    labelField2: '',
    labelField3: '',
    labelField4: '',
    labelField5: '',
    registerField1: '',
    registerField2: '',
    registerField3: '',
    registerField4: '',
    registerField5: '',
    registerField6: '',
    registerField7: '',
    registerField8: '',
    registerField9: '',
    registerField10: '',
    registerField11: '',
    registerField12: '',
    registerField13: '',
    registerField14: '',
    registerField15: '',
    registerField16: '',
    registerField17: '',
    registerField18: '',
    registerField19: '',
    registerField20: '',
    colorBackground: '#456091',
    colorText: 'white',
    colorButton: 'white',
    colorTextButton: 'black',
    serchGuestsText: '',
    customZebraLabelText: '',
    signatureTerms: '',
    guestIdentifier: '',
    confirmationField1: '',
    confirmationField2: '',
    confirmationField3: '',
    confirmationField4: '',
    confirmationField5: '',
    blockQrCode: '',
    scheduleSerialNumber: '',
    urlKioskMode2: '',
    urlKioskModeLandscape2: '',
  });
  const configListFormRef = useRef();
  useEffect(() => {
    configListFormRef.current = configListForm;
  }, [configListForm]);

  useEffect(() => {
    getData();
  }, []);

  const getData = React.useCallback(async () => {
    try {
      setLoadingControl({ ...loadingControl, open: true, message: 'Carregando' });

      const _plusXMiceId = await plusXMiceIdService.getPlusXMiceId(eventId);
      setPlusXMiceId(_plusXMiceId);

      setTimeout(() => {
        if (plusXMiceIdRef.current.miceId && plusXMiceIdRef.current.active) {
          getEventData();
        }
      }, 100);

    } catch (error) {
      console.log('Error getData', error);
      setAlertControl({
        open: true,
        title: 'Erro',
        message: error.message || 'Não foi possível realizar esta operação',
        status: 'error', // success, warning, error
      });
    } finally {
      setLoadingControl({ ...loadingControl, open: false });
    }
  }, [
    // configsList,
    // configValuesForm
  ]);

  const tryActiveAccreditation = React.useCallback(async () => {
    try {
      setLoadingControl({ ...loadingControl, open: true, message: 'Salvando' });

      if (!plusXMiceId.miceId) {
        setAlertControl({
          open: true,
          title: '',
          message: 'ID do evento do Mice obrigatório',
          status: 'warning', // success, warning, error
        });
        return;
      }

      await plusXMiceIdService.savePlusXMiceId(props?.user?.email, eventId, plusXMiceId.miceId, !plusXMiceId.active);

      setPlusXMiceId({ ...plusXMiceId, plusId: eventId, active: !plusXMiceId.active });

      setTimeout(() => {
        if (plusXMiceIdRef.current.active) {
          getEventData();
        }
      }, 100);

    } catch (error) {
      console.log('Error tryActiveAccreditation', error);
      setAlertControl({
        open: true,
        title: 'Erro',
        message: error.message || 'Não foi possível realizar esta operação',
        status: 'error', // success, warning, error
      });
    } finally {
      setLoadingControl({ ...loadingControl, open: false });
    }
  }, [plusXMiceId]);

  const getEventData = React.useCallback(async () => {
    try {
      setLoadingControl({ ...loadingControl, open: true, message: 'Carregando' });

      const _token = await adminUserService.getAdminTokenApi(plusXMiceIdRef.current.miceId);

      let _configList = await adminUserService.getConfigListApi(plusXMiceIdRef.current.miceId);

      let _mergeConfigList = mergeConfigList(_configList);
      setConfigListAtFormObject(_mergeConfigList);
      setConfigListBase(_mergeConfigList)

      let _attributes = await adminUserService.getAttributesListApi(_token, plusXMiceIdRef.current.miceId);
      let _attributesList = getAttributesList(_attributes);
      setAttributesList(_attributesList);

      let _attributesListLabel = getFilteredAttributesListLabel(_attributes);
      setAttributesListLabel(_attributesListLabel);

      let _schedules = await scheduleService.getSchedulesHallApi(plusXMiceIdRef.current.miceId);
      setSchedulesList(_schedules);

      try {
        const _doctorReport = await eventDoctorService.getEventDoctorApi(plusXMiceIdRef.current.miceId);
        if (_doctorReport) {
          setAlertControl({
            open: true,
            title: 'Atenção',
            message: `${_doctorReport} \n\nA não correção destas inconsistências pode resultar em problemas de sincronização ou perda de dados`,
            status: 'warning',
          });
        }
      } catch (error) {
        console.log('Error eventDoctor', error);
      }

    } catch (error) {
      console.log('Error getEventData', error);
      setAlertControl({
        open: true,
        title: 'Erro',
        message: error.message || 'Não foi possível realizar esta operação',
        status: 'error', // success, warning, error
      });
    } finally {
      setLoadingControl({ ...loadingControl, open: false });
    }

    function mergeConfigList(configList = []) {
      let _return = adminUserService.getInitialConfigList();
      configList.forEach(item => {
        let _index = _return.findIndex(c => { return c.fieldId === item.fieldId });
        if (_index >= 0) {
          _return[_index] = item;
        }
      });
      return _return;
    }

    function setConfigListAtFormObject(configList = []) {
      configList.forEach(item => {
        switch (item.fieldId) {
          case 1:
            configListFormRef.current.urlKioskMode = item.value;
            break;
          case 3:
            configListFormRef.current.colorBackground = item.value;
            break;
          case 4:
            configListFormRef.current.colorText = item.value;
            break;
          case 5:
            configListFormRef.current.colorButton = item.value;
            break;
          case 6:
            configListFormRef.current.colorTextButton = item.value;
            break;
          case 7:
            configListFormRef.current.confirmedGuests = item.value;
            break;
          case 8:
            configListFormRef.current.labelModel = item.value;
            break;
          case 9:
            configListFormRef.current.labelField1 = item.value;
            break;
          case 10:
            configListFormRef.current.labelField2 = item.value;
            break;
          case 11:
            configListFormRef.current.labelField3 = item.value;
            break;
          case 12:
            configListFormRef.current.labelField4 = item.value;
            break;
          case 13:
            configListFormRef.current.labelField5 = item.value;
            break;
          case 14:
            configListFormRef.current.registerField1 = item.value;
            break;
          case 15:
            configListFormRef.current.registerField2 = item.value;
            break;
          case 16:
            configListFormRef.current.registerField3 = item.value;
            break;
          case 17:
            configListFormRef.current.registerField4 = item.value;
            break;
          case 18:
            configListFormRef.current.registerField5 = item.value;
            break;
          case 19:
            configListFormRef.current.registerField6 = item.value;
            break;
          case 20:
            configListFormRef.current.registerField7 = item.value;
            break;
          case 21:
            configListFormRef.current.serchGuestsText = item.value;
            break;
          case 22:
            configListFormRef.current.customZebraLabelText = item.value;
            break;
          case 23:
            configListFormRef.current.urlKioskModeLandscape = item.value;
            break;
          case 24:
            configListFormRef.current.signatureTerms = item.value;
            break;
          case 25:
            configListFormRef.current.guestIdentifier = item.value;
            break;
          case 26:
            configListFormRef.current.confirmationField1 = item.value;
            break;
          case 27:
            configListFormRef.current.confirmationField2 = item.value;
            break;
          case 28:
            configListFormRef.current.confirmationField3 = item.value;
            break;
          case 29:
            configListFormRef.current.confirmationField4 = item.value;
            break;
          case 30:
            configListFormRef.current.confirmationField5 = item.value;
            break;
          case 31:
            configListFormRef.current.blockQrCode = item.value;
            break;
          case 32:
            configListFormRef.current.urlKioskMode2 = item.value;
            break;
          case 33:
            configListFormRef.current.urlKioskModeLandscape2 = item.value;
            break;
          case 34:
            configListFormRef.current.registerField8 = item.value;
            break;
          case 35:
            configListFormRef.current.registerField9 = item.value;
            break;
          case 36:
            configListFormRef.current.registerField10 = item.value;
            break;
          case 37:
            configListFormRef.current.registerField11 = item.value;
            break;
          case 38:
            configListFormRef.current.registerField12 = item.value;
            break;
          case 39:
            configListFormRef.current.registerField13 = item.value;
            break;
          case 40:
            configListFormRef.current.registerField14 = item.value;
            break;
          case 41:
            configListFormRef.current.registerField15 = item.value;
            break;
          case 42:
            configListFormRef.current.registerField16 = item.value;
            break;
          case 43:
            configListFormRef.current.registerField17 = item.value;
            break;
          case 44:
            configListFormRef.current.registerField18 = item.value;
            break;
          case 45:
            configListFormRef.current.registerField19 = item.value;
            break;
          case 46:
            configListFormRef.current.registerField20 = item.value;
            break;
          case 47:
            configListFormRef.current.scheduleSerialNumber = item.value;
            break;
          default:
            break;
        }
      });

      setConfigListForm(configListFormRef.current);
    }

    function getAttributesList(attributes = []) {
      let _return = [];
      attributes.forEach(item => {
        if (item.DbReferencia !== 'Nome') {
          _return.push({
            text: item.Nome,
            value: item.ID,
            dbReference: item.DbReferencia
          });
        }
      });
      return _return;
    }

    function getFilteredAttributesListLabel(attributes = []) {
      let _return = [];
      attributes.forEach(item => {
        _return.push({
          text: item.Nome,
          value: item.ID,
          dbReference: item.DbReferencia || item.Nome
        });
      });
      return _return;
    }
  }, [plusXMiceId, plusXMiceIdRef, configListBase]);

  const trySaveConfigs = React.useCallback(async () => {
    try {
      setLoadingControl({ ...loadingControl, open: true, message: 'Salvando' });

      let _configList = setFormObjectToConfigList(configListForm);
      _configList = await saveDataAtApi(_configList);

      setConfigListBase(_configList);

      setAlertControl({
        ...alertControl,
        open: true,
        title: 'Salvo',
        message: 'Configurações salvas com sucesso',
        status: 'success'
      });

    } catch (error) {
      console.log('Error trySaveConfigs', error);
      setAlertControl({
        open: true,
        title: 'Erro',
        message: error.message || 'Não foi possível realizar esta operação',
        status: 'error', // success, warning, error
      });
    } finally {
      setLoadingControl({ ...loadingControl, open: false });
    }

    function setFormObjectToConfigList(configList) {
      let _return = [...configListBase];
      for (var key in configList) {
        let _key = key;
        let _fieldId = 0;
        switch (_key) {
          case 'urlKioskMode':
            _fieldId = 1;
            break;
          case 'colorBackground':
            _fieldId = 3;
            break;
          case 'colorText':
            _fieldId = 4;
            break;
          case 'colorButton':
            _fieldId = 5;
            break;
          case 'colorTextButton':
            _fieldId = 6;
            break;
          case 'confirmedGuests':
            _fieldId = 7;
            break;
          case 'labelModel':
            _fieldId = 8;
            break;
          case 'labelField1':
            _fieldId = 9;
            break;
          case 'labelField2':
            _fieldId = 10;
            break;
          case 'labelField3':
            _fieldId = 11;
            break;
          case 'labelField4':
            _fieldId = 12;
            break;
          case 'labelField5':
            _fieldId = 13;
            break;
          case 'registerField1':
            _fieldId = 14;
            break;
          case 'registerField2':
            _fieldId = 15;
            break;
          case 'registerField3':
            _fieldId = 16;
            break;
          case 'registerField4':
            _fieldId = 17;
            break;
          case 'registerField5':
            _fieldId = 18;
            break;
          case 'registerField6':
            _fieldId = 19;
            break;
          case 'registerField7':
            _fieldId = 20;
            break;
          case 'serchGuestsText':
            _fieldId = 21;
            break;
          case 'customZebraLabelText':
            _fieldId = 22;
            break;
          case 'urlKioskModeLandscape':
            _fieldId = 23;
            break;
          case 'signatureTerms':
            _fieldId = 24;
            break;
          case 'guestIdentifier':
            _fieldId = 25;
            break;
          case 'confirmationField1':
            _fieldId = 26;
            break;
          case 'confirmationField2':
            _fieldId = 27;
            break;
          case 'confirmationField3':
            _fieldId = 28;
            break;
          case 'confirmationField4':
            _fieldId = 29;
            break;
          case 'confirmationField5':
            _fieldId = 30;
            break;
          case 'blockQrCode':
            _fieldId = 31;
            break;
          case 'urlKioskMode2':
            _fieldId = 32;
            break;
          case 'urlKioskModeLandscape2':
            _fieldId = 33;
            break;
          case 'registerField8':
            _fieldId = 34;
            break;
          case 'registerField9':
            _fieldId = 35;
            break;
          case 'registerField10':
            _fieldId = 36;
            break;
          case 'registerField11':
            _fieldId = 37;
            break;
          case 'registerField12':
            _fieldId = 38;
            break;
          case 'registerField13':
            _fieldId = 39;
            break;
          case 'registerField14':
            _fieldId = 40;
            break;
          case 'registerField15':
            _fieldId = 41;
            break;
          case 'registerField16':
            _fieldId = 42;
            break;
          case 'registerField17':
            _fieldId = 43;
            break;
          case 'registerField18':
            _fieldId = 44;
            break;
          case 'registerField19':
            _fieldId = 45;
            break;
          case 'registerField20':
            _fieldId = 46;
            break;
          case 'scheduleSerialNumber':
            _fieldId = 47;
            break;
          default:
            break;
        }
        let _index = _return.findIndex(c => { return c.fieldId === _fieldId });
        if (typeof _index === "number" && _index >= 0) {
          _return[_index].value = configList[_key];
        }
      }
      return _return;
    }

    async function saveDataAtApi(configList = []) {
      try {
        let _return = configList;
        if (configList.length === 0) {
          return _return;
        }

        let _count = 0;
        do {
          let _item = _return[_count];
          _return[_count] = await adminUserService.saveConfigApi(
            plusXMiceIdRef.current.miceId,
            _item.fieldId,
            _item.value
          );
          _count++;
        } while (_count < _return.length);
        return _return;
      } catch (error) {
        console.log('Error saveDataAtApi', error);
        throw error;
      }
    }
  }, [configListForm, configListBase]);

  return (
    <div>
      <HasEventForm
        plusXMiceId={plusXMiceId}
        setPlusXMiceId={setPlusXMiceId}
        tryActiveAccreditation={tryActiveAccreditation}
      />
      {plusXMiceId.active && (
        <ConfigurationsList
          configListForm={configListForm}
          setConfigListForm={setConfigListForm}
          trySaveConfigs={trySaveConfigs}
          attributesList={attributesList}
          attributesListLabel={attributesListLabel}
          schedulesList={schedulesList}
        />
      )}

      <Loading loadingControl={loadingControl} />
      <Alert
        alertControl={alertControl}
        setAlertControl={setAlertControl}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  const user = state.global_user_data.data.foundLogin;
  return { user: user };
};

export default connect(mapStateToProps)(AccreditationConfigurations);
